import { CREATE_UPLOAD_USERS_SUCCESS, CREATE_UPLOAD_USERS_FAILURE } from '../actions/users';
import { showFlashMessage } from '../actions/ui';

const uploadUsers =
  ({ dispatch }) =>
  next =>
  action => {
    switch (action.type) {
      case CREATE_UPLOAD_USERS_SUCCESS:
        dispatch(
          showFlashMessage('Users created', {
            type: 'success',
          }),
        );
        break;

      case CREATE_UPLOAD_USERS_FAILURE:
        dispatch(
          showFlashMessage(`${action.payload.message}`, {
            type: 'error',
          }),
        );
        break;

      default:
        break;
    }

    return next(action);
  };

export default uploadUsers;
